<template>
  <div class="mydemanddetail">
    <div class="page-title">
      <div class="page-nav-items">
        <span class="page-parentname" @click="Back">BUG详情></span
        ><span>{{ showOperateName }}</span>
      </div>
    </div>
    <el-form
      ref="bugForm"
      :model="bugForm"
      class="form-box"
      label-width="100px"
      label-position="left"
    >
      <el-form-item prop="mid_table_remark_009" label="测试人员/ID:">
        <template>
          <div class="custom-input txt-normalstyle width360">
            <b v-if="operateName === 'new'">{{
              userInfo.nick_name + "/" + userInfo.id_public_user_info
            }}</b>
            <b v-else
              >{{ bugForm.mid_table_remark_009 || "" }}/{{
                bugForm.id_public_user_info || ""
              }}</b
            >
          </div>
        </template>
      </el-form-item>
      <el-form-item
        label="问题描述："
        prop="mid_table_remark_013"
        :rules="rules.mid_table_remark_013"
      >
        <template>
          <el-input
            class="custom-input txt-normalstyle project-desc custom-txt"
            v-model="bugForm.mid_table_remark_013"
            maxlength="50"
            show-word-limit
            placeholder="请填写"
          ></el-input>
        </template>
      </el-form-item>
      <div class="twoitem-row" v-if="operateName !== 'new'">
        <div class="width460">
          <el-form-item prop="time_insert" label="测试时间：">
            <template>
              <el-input
                class="custom-input txt-normalstyle width360"
                placeholder="-"
                :value="bugForm.time_insert | showTime"
                :readonly="true"
              >
              </el-input>
            </template>
          </el-form-item>
        </div>
        <div class="width460">
          <el-form-item prop="time_update" label="完成时间：">
            <template>
              <el-input
                class="custom-input txt-normalstyle width360"
                placeholder="-"
                v-model="bugForm.mid_table_remark_011"
                :readonly="true"
              >
              </el-input>
            </template>
          </el-form-item>
        </div>
      </div>

      <div class="twoitem-row">
        <div>
          <el-form-item
            prop="mid_table_remark_002"
            label="角色端口："
            :rules="rules.mid_table_remark_002"
          >
            <el-input
              class="custom-input txt-normalstyle width360"
              placeholder="请输入BUG涉及的角色端口"
              v-model="bugForm.mid_table_remark_002"
            >
            </el-input>
          </el-form-item>
        </div>
        <div class="width460" style="margin-left: 36px;">
          <el-form-item
            prop="mid_table_remark_010"
            label="涉及页面："
            :rules="rules.mid_table_remark_010"
          >
            <el-input
              class="custom-input txt-normalstyle width360"
              placeholder="请输入BUG涉及的页面路由"
              v-model="bugForm.mid_table_remark_010"
            >
            </el-input>
          </el-form-item>
        </div>
      </div>
      <el-form-item
        label="测试case："
        prop="mid_table_remark_004"
        :rules="rules.mid_table_remark_004"
      >
        <template>
          <el-input
            class="custom-input txt-normalstyle project-desc custom-txt"
            v-model="bugForm.mid_table_remark_004"
            type="textarea"
            maxlength="200"
            show-word-limit
            placeholder="请填写"
          ></el-input>
        </template>
      </el-form-item>
      <el-form-item
        label="功能："
        prop="mid_table_remark_005"
        :rules="rules.mid_table_remark_005"
      >
        <template>
          <el-input
            class="custom-input txt-normalstyle project-desc custom-txt"
            v-model="bugForm.mid_table_remark_005"
            type="textarea"
            maxlength="200"
            show-word-limit
            placeholder="请描述"
          ></el-input>
        </template>
      </el-form-item>
      <el-form-item label="图例:">
        <UploadImages
          ref="goodsDescImage"
          :keyWord="'goodsDescImage'"
          :limit="9"
          @imagesData="getImageFile"
        ></UploadImages>
        <span style="cursor: pointer" @click="DetailImg">点击查看</span>
      </el-form-item>
      <el-form-item label="视频:">
        <UploadVideo
          ref="goodsVideo"
          :limit="1"
          @imagesData="getVideoData"
        ></UploadVideo>
      </el-form-item>
      <el-form-item
        v-if="
          bugForm.mid_table_remark_012 && bugForm.mid_table_remark_012 !== '-1'
        "
      >
        <template>
          <video
            :src="bugForm.mid_table_remark_012"
            width="50%"
            controls="controls"
          ></video>
        </template>
      </el-form-item>
      <el-form-item prop="mid_table_remark_007" label="修复备注：">
        <template>
          <el-input
            class="custom-input txt-normalstyle"
            placeholder="-"
            v-model="bugForm.mid_table_remark_007"
            :readonly="true"
          >
          </el-input>
        </template>
      </el-form-item>
      <div class="twoitem-row">
        <el-form-item prop="mid_table_remark_006" label="跟踪记录：">
          <template>
            <el-table :data="requestList" stripe style="width: 100%">
              <el-table-column type="index" label="序号" width="60">
              </el-table-column>
              <el-table-column
                prop="mid_table_remark_009"
                label="测试人员"
                width="140"
              >
              </el-table-column>
              <el-table-column prop="time_insert" label="跟踪时间" width="160">
              </el-table-column>
              <el-table-column
                prop="mid_table_remark_002"
                label="备注"
                width="250"
              >
              </el-table-column>
              <el-table-column
                label="跟踪记录图例"
                width="150"
                text-align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="traceRecordsImg(scope.row)"
                  >
                    查看图例
                  </el-button>
                </template></el-table-column
              >
              <el-table-column
                label="跟踪记录视频"
                width="150"
                text-align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="traceRecordsVideo(scope.row)"
                  >
                    查看视频
                  </el-button>
                </template></el-table-column
              >
            </el-table>
          </template>
        </el-form-item>
      </div>
      <el-form-item>
        <template v-if="operateName !== 'search'">
          <el-button
            v-if="operateName === 'new'"
            class="custom-button btn-ff3333 btn-publish"
            @click="handleSubmit"
            >提交</el-button
          >
          <el-button
            v-else-if="
              userInfo.id_public_user_info == bugForm.id_public_user_info &&
              bugForm.mid_table_remark_008 == 0
            "
            @click="handleSubmit"
            :class="
              bugForm.mid_table_remark_008 == 1
                ? 'diabled custom-button btn-e0e0e0 btn-publish'
                : 'custom-button btn-ff3333 btn-publish'
            "
            >编辑</el-button
          >
          <!-- <el-button
            v-else
            @click="handleSubmit"
            class="diabled custom-button btn-e0e0e0 btn-publish"
            >编辑</el-button
          >  -->
          <el-button
            class="custom-button btn-border btn-back"
            @click="handleBack"
            >返回</el-button
          >
        </template>
      </el-form-item>
    </el-form>
    <el-dialog
      title="查看图例 (点击图片可放大)"
      width="35%"
      :visible.sync="dialogDetailImgVisible"
    >
      <div class="dialog-content">
        <el-carousel trigger="click">
          <el-carousel-item v-for="(item, index) in Detailimg" :key="index">
            <el-image
              :src="item"
              :preview-src-list="Detailimg"
              fit="contain"
              width="30%"
              style="height: 100%"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog>
    <el-dialog
      title="跟踪记录图例"
      width="35%"
      :visible.sync="dialogImgVisible"
    >
      <div class="dialog-content">
        <el-carousel trigger="click">
          <el-carousel-item v-for="(item, index) in imgList" :key="index">
            <el-image
              :src="item"
              :preview-src-list="imgList"
              fit="contain"
              width="30%"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog>
    <el-dialog
      title="跟踪记录视频"
      width="35%"
      :visible.sync="dialogVideoVisible"
    >
      <div class="dialog-content">
        <video :src="videoUrl" width="100%" controls="controls"></video>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Base64 } from "js-base64";
import storage from "@/utils/customLocalStorage";
import UploadVideo from "@/components/UploadVideo/UploadVideo";
import UploadImages from "@/components/UploadImages/UploadImages";
import { checkDataFromDictionary, formatDate } from "@/utils/tool";
import lodash from "lodash";
import pageCommon from "@/utils/pagecommon";
import bugApi from "@/api/bug";
import messageApi from "@/api/message";

export default {
  name: "BUGDetail",
  components: {
    UploadImages,
    UploadVideo,
  },
  mounted() {
    let _this = this;
  },
  data() {
    return {
      operateName: "",
      bugId: "",
      projectId: "",
      bugForm: {},
      rules: {
        mid_table_remark_002: [
          { required: true, message: "请填写涉及的角色端口", trigger: "blur" },
        ],
        mid_table_remark_004: [
          { required: true, message: "请填写测试case", trigger: "blur" },
        ],
        mid_table_remark_005: [
          { required: true, message: "请填写功能", trigger: "blur" },
        ],
        mid_table_remark_010: [
          { required: true, message: "请填写涉及的页面", trigger: "blur" },
        ],
        mid_table_remark_013: [
          { required: true, message: "请填写问题描述", trigger: "blur" },
        ],
      },
      isRequesting: false,
      tipShow: true,
      requestList: [],
      imgList: [],
      Detailimg: [],
      dialogDetailImgVisible: false,
      dialogImgVisible: false,
      dialogVideoVisible: false,
      videoUrl: "",
    };
  },
  computed: {
    userInfo: function () {
      let _this = this;
      let user = _this.$store.state.user;
      _this.tipShow = user.user_remark_012 === "1202" ? false : true;
      return user;
    },
    showOperateName: function () {
      let _this = this;
      if (_this.operateName === "new") {
        return "新增测试BUG";
      }
      if (_this.operateName === "edit") {
        return "查看&编辑";
      }
    },
  },
  created() {
    let _this = this;
    let operate = _this.$route.query.o;
    if (!operate) {
      _this.$router.go(-1);
      return;
    }
    _this.projectId = _this.$route.query.projectId;
    let id = _this.$route.query.id;
    if (operate !== "new" && !id && id !== 0) {
      _this.$router.go(-1);
      return;
    }
    _this.operateName = operate;
    _this.bugId = id;
    if (_this.bugId) {
      // 获取BUG清单详情
      _this.getBugDetail();
      // 获取跟踪记录详情
      _this.getTraceRecords();
    } else {
      _this.bugForm = {
        // 角色端口
        mid_table_remark_002: null,
        // 测试case
        mid_table_remark_004: null,
        // 功能
        mid_table_remark_005: null,
        // 图例
        mid_table_remark_006: null,
        // 备注
        mid_table_remark_007: null,
        // 涉及页面
        mid_table_remark_010: null,
        // 上传视频
        mid_table_remark_012: null,
        // 问题描述
        mid_table_remark_013: null,
      };
      _this.$nextTick(() => {
        _this.$refs.bugForm.clearValidate();
      });
    }
  },
  filters: {
    showTime: function (val) {
      if (!val) {
        return;
      }
      let time = formatDate(
        new Date(val.replace(/-/g, "/")),
        "YYYY.MM.DD hh:mm:ss"
      );
      return time;
    },
  },
  methods: {
    Back: function () {
      let _this = this;
      _this.$router.go(-1);
    },
    getBugDetail: function () {
      let _this = this;
      let requestData = {
        begin_idx: 0,
        isloading: true,
        id_public_middle_table: _this.bugId,
      };
      pageCommon.apiRequestCommon(bugApi, "getDetail", requestData).then(
        (res) => {
          let tmp =
            res && res.page_content && res.page_content.length
              ? res.page_content[0]
              : null;
          if (!tmp) {
            _this.$router.go(-1);
            return;
          }
          _this.bugForm = tmp;
          console.log(_this.bugForm);
          if (
            _this.bugForm.mid_table_remark_006 &&
            _this.bugForm.mid_table_remark_006 !== "-1"
          ) {
            this.$refs.goodsDescImage.goodsDescImage = [];
            let imageData = _this.bugForm.mid_table_remark_006.split(",");
            imageData.forEach((item) => {
              this.$refs.goodsDescImage.goodsDescImage.push({
                image_url: item,
              });
            });
          }
          /* 视频 */
          if (
            _this.bugForm.mid_table_remark_012 &&
            _this.bugForm.mid_table_remark_012 !== "-1"
          ) {
            this.$refs.goodsVideo.goodsImageList = [
              {
                image_url: _this.bugForm.mid_table_remark_012,
              },
            ];
          }
          _this.$nextTick(() => {
            _this.$refs.bugForm.clearValidate();
          });
        },
        (err) => {
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
          _this.$router.go(-1);
        }
      );
    },
    /*
     * 获取视频文件
     * */
    getVideoData(data) {
      let _this = this;
      data.length
        ? (_this.bugForm.mid_table_remark_012 = data[0].image_url)
        : (_this.bugForm.mid_table_remark_012 = "-1");
    },
    // 查看测试详情的图片
    DetailImg: function (row) {
      let _this = this;
      if (
        _this.bugForm.mid_table_remark_006 &&
        _this.bugForm.mid_table_remark_006 != -1
      ) {
        _this.Detailimg = _this.bugForm.mid_table_remark_006.split(",");
        _this.dialogDetailImgVisible = true;
      } else {
        _this.$message("暂无图例");
      }
    },
    // 查看2002跟踪记录的图片
    traceRecordsImg: function (row) {
      let _this = this;
      if (row.mid_table_remark_006 && row.mid_table_remark_006 != -1) {
        _this.imgList = row.mid_table_remark_006.split(",");
        _this.dialogImgVisible = true;
      } else {
        _this.$message("暂无图例");
      }
    },
    // 查看2002跟踪记录的视频
    traceRecordsVideo: function (row) {
      let _this = this;
      if (row.mid_table_remark_012 && row.mid_table_remark_012 != -1) {
        _this.videoUrl = row.mid_table_remark_012;
        _this.dialogVideoVisible = true;
      } else {
        _this.$message("暂无视频");
      }

      // console.log(row);
    },
    // 获取2002跟踪记录的数据
    getTraceRecords: function () {
      let _this = this;
      // console.log(_this.bugId);
      let requestData = {
        begin_idx: 0,
        // limit: 10,
        isloading: true,
        mid_table_remark_010: _this.bugId,
      };
      pageCommon.apiRequestCommon(bugApi, "TraceRecords", requestData).then(
        (res) => {
          // console.log(res.page_content);
          _this.requestList = res.page_content;
          _this.$nextTick(() => {
            _this.$refs.bugForm.clearValidate();
          });
        },
        (err) => {
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
          _this.$router.go(-1);
        }
      );
    },
    // 新建/修改
    handleSubmit: function () {
      let _this = this;
      _this.isRequesting = true;
      _this.$refs["bugForm"].validate((valid) => {
        if (valid) {
          _this.submitBug();
        } else {
          _this.isRequesting = false;
        }
      });
    },
    // 新增和编辑
    submitBug: function () {
      let _this = this;
      if (_this.bugForm.mid_table_remark_012 == null) {
        _this.bugForm.mid_table_remark_012 = "-1";
      }
      let page_content = {
        id_public_user_info: _this.userInfo.id_public_user_info,
        mid_table_remark_001: _this.projectId,
        mid_table_remark_002: _this.bugForm.mid_table_remark_002,
        mid_table_remark_004: _this.bugForm.mid_table_remark_004,
        mid_table_remark_005: _this.bugForm.mid_table_remark_005,
        mid_table_remark_006: _this.bugForm.mid_table_remark_006,
        mid_table_remark_007: _this.bugForm.mid_table_remark_007,
        mid_table_remark_008: 0,
        type_inner_app: 0,
        mid_table_remark_009: _this.userInfo.nick_name,
        mid_table_remark_010: _this.bugForm.mid_table_remark_010,
        mid_table_remark_012: _this.bugForm.mid_table_remark_012,
        mid_table_remark_013: _this.bugForm.mid_table_remark_013,
        isloading: true,
        is_online: 0,
        type_inner_app: 1001,
      };
      let user_list={
        isloading: true,
        user_list: _this.$route.query.partner&&_this.$route.query.partner.length>0?_this.userInfo.id_public_user_info+','+_this.$route.query.partner:_this.userInfo.id_public_user_info,
        pre_cmd_para_show_desc:_this.$route.query.projectName + '项目新增一条buglist'
      }
      if (_this.bugId) {
        page_content["id_public_middle_table"] = _this.bugId;
      }
      pageCommon.apiRequestCommon(bugApi, "createBug", page_content).then(
        (res) => {
          pageCommon.apiRequestCommon(messageApi, "sendMessage", user_list).then(
            (res) => {
              _this.isRequesting = false;
              _this.$router.go(-1);
              _this.$message.success("操作成功~");
            },
            (err) => {
              console.log(err)
              _this.isRequesting = false;
              if (err.sysUserLoginError) {
                _this.$message.error("系统异常，请稍后刷新重试！");
              } else {
                _this.$message.error(err.data.msg);
              }
            }
          );
        },
        (err) => {
          _this.isRequesting = false;
          if (err.sysUserLoginError) {
            _this.$message.error("系统异常，请稍后刷新重试！");
          } else {
            _this.$message.error(err.data.msg);
          }
        }
      );
    },
    handleBack: function () {
      let _this = this;
      _this.$router.go(-1);
    },
    /*
     * 获取图片文件
     * */
    getImageFile(data, type) {
      let _this = this;

      if (data.length) {
        let newImageData = [];
        data.forEach((item) => {
          newImageData.push(item.image_url);
        });
        _this.bugForm.mid_table_remark_006 = newImageData.join(",");
      } else {
        _this.bugForm.mid_table_remark_006 = "-1";
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
@import "../../assets/css/center.less";

.mydemanddetail {
  position: relative;
  width: 100%;
  height: 100%;
  padding-left: 40px;
  padding-right: 40px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;

  .width360 {
    width: 360px;
  }

  .width460 {
    width: 460px;
  }

  .width856 {
    width: 856px;
  }

  .icon-remind {
    margin-left: 15px;
    width: 18px;
    height: 18px;
    cursor: pointer;
  }

  .page-title {
    position: relative;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .page-nav-items {
      .page-parentname {
        color: rgba(153, 153, 153, 1);
        cursor: pointer;
      }
    }
  }

  .appid-secret-box {
    position: relative;
    width: 100%;
    height: 140px;
    background: #f4f4f4;

    &.checkoredit {
      background: url(~@/assets/icon_human.png) no-repeat 870px 20px #f4f4f4;
      background-size: 100px 100px;
    }

    border: 1px solid #eeeeee;
    border-radius: 4px;
    box-sizing: border-box;
    margin-top: 40px;

    .appid-secret-main {
      position: relative;
      width: 100%;
      height: 64px;
      display: flex;
      display: -webkit-flex;
      flex-direction: column;
      justify-content: space-between;
      margin-top: 40px;
      margin-left: 101px;

      .item-container {
        position: relative;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        align-items: center;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #222222;
        line-height: 22px;

        .label {
          position: relative;
          width: 125px;

          text-align: left;
        }

        .dot {
          position: relative;
          padding-left: 16px;
          padding-right: 24px;
        }
      }
    }
  }

  .form-box {
    position: relative;
    width: 100%;
    padding-top: 40px;
    padding-bottom: 48px;
    box-sizing: border-box;

    /deep/ .el-form-item {
      margin-bottom: 40px;
    }

    .twoitem-row {
      position: relative;
      width: 100%;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      //justify-content: space-between;
    }

    /deep/ .el-form-item__content {
      text-align: left;
    }

    .custom-txt {
      width: 690px;
    }

    .tip-upload {
      position: relative;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
    }

    .upload-btn-files-box {
      position: relative;
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;

      .btn-upload {
        width: 94px;
        height: 36px;
        line-height: 36px;

        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        // color: #ec4040;
      }

      .files-box {
        position: relative;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        flex-wrap: wrap;

        .item {
          position: relative;
          display: flex;
          align-items: center;

          border-radius: 4px;
          background-color: rgb(246, 246, 246);
          height: 36px;
          // line-height: 24px;
          padding-left: 5px;
          padding-right: 5px;
          box-sizing: border-box;
          margin-left: 20px;

          font-size: 12px;
          font-family: "SourceHanSansCN";
          color: rgb(34, 34, 34);
          box-sizing: border-box;

          .filename {
            max-width: 200px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .el-icon-close {
            font-size: 12px;
            margin-left: 5px;
            cursor: pointer;
          }
        }

        &.justshow {
          .item {
            background: #fff8f8;

            .filename {
              color: #ec4040;
            }

            &:first-child {
              margin-left: 0;
            }

            .el-icon-close {
              display: none;
            }
          }
        }
      }
    }

    /deep/ .custom-input {
      &.input-with-unit {
        .el-input__inner {
          padding-right: 46px;
        }

        &::after {
          position: absolute;
          content: "万";
          width: 46px;
          height: 46px;
          line-height: 46px;
          right: 0;
          top: 0;

          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: normal;
          color: #222222;
          text-align: center;
        }
      }

      &.project-desc {
        width: 889px;

        .el-textarea__inner {
          position: relative;
          width: 889px;
          height: 170px;

          padding: 17px 13px;
          resize: none;

          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: normal;
          color: #222222;
          line-height: 24px;

          &:focus {
            border-color: #07060b;
          }

          &::placeholder {
            color: #c2c2c2;
          }

          &::-webkit-input-placeholder {
            /* WebKit browsers 适配谷歌 */
            color: #c2c2c2;
          }

          &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 适配火狐 */
            color: #c2c2c2;
          }

          &::-moz-placeholder {
            /* Mozilla Firefox 19+ 适配火狐 */
            color: #c2c2c2;
          }

          &:-ms-input-placeholder {
            /* Internet Explorer 10+  适配ie*/
            color: #c2c2c2;
          }
        }
      }

      background-color: #fff;
    }

    .picker-uptime {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
    }

    .btn-publish {
      width: 110px;
      height: 46px;
      line-height: 46px;

      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
    }

    .btn-cancel {
      width: 94px;
      height: 46px;
      line-height: 46px;

      font-size: 16px;
      font-family: Source Han Sans CN;
      // font-weight: bold;
      background-color: #ec4040;
      line-height: 16px;
      color: #fff;
    }

    .btn-back {
      width: 94px;
      height: 46px;

      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ec4040;
      line-height: 46px;
    }
  }

  .cell-row {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    align-items: center;
    padding-left: 25px;
    padding-right: 25px;
    box-sizing: border-box;

    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
    text-align: left;
    // margin-right: 20px;
  }

  .cell-column {
    position: relative;
    text-align: left;
    flex-shrink: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }

  .project-name-cell {
    position: relative;
    width: 156px;
    margin-right: 20px;
  }

  .id-secret-cell {
    position: relative;
    width: 187px;
    margin-right: 25px;
  }

  .status-cell {
    position: relative;
    width: 65px;
    margin-right: 35px;
  }

  .white-cell {
    position: relative;
    width: 96px;
    margin-right: 30px;
  }

  .creattime-cell {
    position: relative;
    width: 83px;
    margin-right: 38px;
  }

  .operate-cell {
    position: relative;
    width: 203px;
    text-align: center;
  }

  .table-header-box {
    position: relative;

    height: 60px;
    background: #f4f4f4;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    box-sizing: border-box;
    margin-top: 35px;
    margin-bottom: 24px;

    .status-cell {
      text-align: center;
    }

    .creattime-cell {
      text-align: center;
    }
  }

  .table-list-box {
    position: relative;
    flex: 1;
    width: 100%;
    margin-bottom: 24px;
    overflow: hidden;
    overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .datalist-row {
    height: 100px;
    background: #ffffff;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    box-sizing: border-box;
    margin-bottom: 24px;

    &:nth-child(2n) {
      background: #f6f6f6;
    }

    &:last-child {
      margin-bottom: 0;
    }

    .cell-column {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #000000;
    }

    .operate-cell {
      position: relative;
      display: flex;
      display: -webkit-flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ec4040;
      line-height: 16px;

      div {
        cursor: pointer;
      }
    }

    .white-cell {
      text-align: center;
    }
  }
  .diabled {
    pointer-events: none;
    color: #ffa8a8;
    cursor: auto;
  }
  .dialog-content {
    .el-image {
      width: 30%;
    }
    .dialog-item {
      margin-bottom: 24px;
      .el-input {
        margin-top: 16px;
        width: 60%;
      }
    }
    .el-row {
      margin-bottom: 16px;
      .el-col {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        &.current {
          align-items: flex-start;
          justify-content: flex-start;
          span {
            margin-top: 10px;
          }
        }
        .el-select {
          width: 200px;
          margin-left: 10px;
        }
        .el-input {
          width: 200px;
          margin-left: 10px;
        }
        .el-textarea {
          width: 200px;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
